import React from 'react';

import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {ConsultRefund} from '../ConsultRefund';
import {ConsultRefundV2} from '../ConsultRefundV2';

export function ConsultRefundEntry() {
	const {isEnabled} = useFeatureFlag(FeaturesEnum.PORTAL_FEATURE_REFUND_CONSULT_V2);

	return isEnabled ? <ConsultRefundV2 /> : <ConsultRefund />;
}
